import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent, TopbarComponent } from '@tw/components';
import { Toast } from 'primeng/toast';
import { SpinnerComponent } from '../shared/components/spinner/spinner.component';

@Component({
  selector: 'tw-app-layout',
  imports: [
    RouterOutlet,
    TopbarComponent,
    SidebarComponent,
    SpinnerComponent,
    Toast,
  ],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss',
})
export class AppLayoutComponent {}
